import type {
  AddFieldCommandOptions,
  BetterstartCommandRuntime
} from '@cli-types/core-engine/commands.js'
import { collectRepeatedOption } from '@cli-utils/shared.js'
import { Command } from 'commander'

export function createAddFieldCommand(runtime: BetterstartCommandRuntime): Command {
  return new Command('add-field')
    .description('Add one field to an existing Generated schema')
    .argument('[schema]', 'Generated schema name (e.g. posts, settings, contact)')
    .option('--cwd <path>', 'Project root path')
    .option('--skip-migration', 'Skip running db:push after generation', false)
    .option(
      '--accept-generated',
      'Accept generated output for files that would otherwise get merge conflicts',
      false
    )
    .option('-y, --yes', 'Confirm warning cases in non-interactive mode', false)
    .option('--type <type>', 'Field type')
    .option('--field <name>', 'Field identifier')
    .option('--label <label>', 'Field label')
    .option('--slot <main|sidebar>', 'Entity or Single layout slot')
    .option('--step <name>', 'Form step target for multi-step form schemas')
    .option('--before <field>', 'Insert before an existing field in the selected target')
    .option('--after <field>', 'Insert after an existing field in the selected target')
    .option('--required', 'Mark the field as required', false)
    .option('--multiple', 'Enable multiple values for supported field types', false)
    .option('--creatable', 'Enable creatable options for Entity or Single select fields', false)
    .option('--option <value:Label>', 'Static select option', collectRepeatedOption, [])
    .option('--relationship <schema>', 'Relationship target schema')
    .action((schemaName: string | undefined, options: AddFieldCommandOptions) =>
      runtime.runAddField(schemaName, options)
    )
}
